import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { ArrowUpRight, Cube } from "@phosphor-icons/react";

const TOUR_URL = "https://tour-piabeta-shopping-center.vercel.app";

export default function Tour360({ compact = false, id = "tour360" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  if (compact) {
    return (
      <div className="rounded-2xl border border-vm-border overflow-hidden bg-vm-muted" data-testid="tour-embed-compact">
        <div className="relative aspect-video">
          <iframe
            src={TOUR_URL}
            title="Tour Virtual 360° — VM Piabetá Shopping Center"
            className="absolute inset-0 w-full h-full"
            loading="lazy"
            allow="fullscreen; xr-spatial-tracking; gyroscope; accelerometer"
            allowFullScreen
          />
        </div>
        <a
          href={TOUR_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 bg-vm-muted text-vm-gold text-sm font-medium py-3 hover:bg-vm-surface transition-colors"
          data-testid="tour-fallback-compact"
        >
          Abrir tour em nova aba <ArrowUpRight size={15} weight="bold" />
        </a>
      </div>
    );
  }

  return (
    <section id={id} ref={ref} className="relative bg-vm-surface py-24 md:py-32" data-testid="tour-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <motion.p initial={{ opacity: 0 }} animate={inView ? { opacity: 1 } : {}} transition={{ duration: 0.6 }} className="text-xs tracking-[0.4em] uppercase text-vm-gold mb-6 flex items-center gap-2">
              <Cube size={16} weight="duotone" /> Tour Virtual 360°
            </motion.p>
            <motion.h2 initial={{ opacity: 0, y: 30 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8 }} className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl" data-testid="tour-title">
              Explore o Shopping <span className="gold-text italic">por Dentro</span>
            </motion.h2>
          </div>
          <a
            href={TOUR_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-sweep relative z-0 inline-flex items-center gap-2 border border-vm-gold text-vm-gold hover:text-vm-bg font-medium px-6 py-3.5 rounded-full shrink-0"
            data-testid="tour-fallback"
          >
            Abrir em nova aba <ArrowUpRight size={18} weight="bold" />
          </a>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="rounded-2xl border border-vm-border overflow-hidden shadow-2xl shadow-black/40"
        >
          <div className="relative aspect-video">
            <iframe
              src={TOUR_URL}
              title="Tour Virtual 360° do VM Piabetá Shopping Center"
              className="absolute inset-0 w-full h-full"
              loading="lazy"
              allow="fullscreen; xr-spatial-tracking; gyroscope; accelerometer"
              allowFullScreen
              data-testid="tour-iframe"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
